/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ExchangeCancelCategory } from './exchange-cancel-category';
// May contain unused imports in some cases
// @ts-ignore
import type { ExchangeManagementUser } from './exchange-management-user';
// May contain unused imports in some cases
// @ts-ignore
import type { ExposeBankAccount } from './expose-bank-account';

/**
 * 
 * @export
 * @interface AdminPatchStatusDataResponseDto
 */
export interface AdminPatchStatusDataResponseDto {
    /**
     * 환급 uuid
     * @type {string}
     * @memberof AdminPatchStatusDataResponseDto
     */
    'exchangeUuid': string;
    /**
     * 환급 신청 금액
     * @type {number}
     * @memberof AdminPatchStatusDataResponseDto
     */
    'amountRequested': number;
    /**
     * 환급 신청 전 환급 가능 금액
     * @type {number}
     * @memberof AdminPatchStatusDataResponseDto
     */
    'exchangeableAmountBeforeRequest': number;
    /**
     * 환급 예정 금액
     * @type {number}
     * @memberof AdminPatchStatusDataResponseDto
     */
    'amountBeExchanged': number;
    /**
     * 세금
     * @type {number}
     * @memberof AdminPatchStatusDataResponseDto
     */
    'tax': number;
    /**
     * 환급 상태
     * @type {string}
     * @memberof AdminPatchStatusDataResponseDto
     */
    'status': AdminPatchStatusDataResponseDtoStatusEnum;
    /**
     * 생성 일시
     * @type {string}
     * @memberof AdminPatchStatusDataResponseDto
     */
    'createdAt': string;
    /**
     * 기타 환급 불가 사유
     * @type {string}
     * @memberof AdminPatchStatusDataResponseDto
     */
    'exchangeCancelOtherReason': string;
    /**
     * 환급 (예정) 일시
     * @type {string}
     * @memberof AdminPatchStatusDataResponseDto
     */
    'exchangeAt': string;
    /**
     * 취소 여부
     * @type {boolean}
     * @memberof AdminPatchStatusDataResponseDto
     */
    'isCancelled': boolean;
    /**
     * 환급 불가 사유
     * @type {ExchangeCancelCategory}
     * @memberof AdminPatchStatusDataResponseDto
     */
    'exchangeCancelCategory': ExchangeCancelCategory;
    /**
     * 노출용 계좌 정보
     * @type {ExposeBankAccount}
     * @memberof AdminPatchStatusDataResponseDto
     */
    'exposeBankAccount': ExposeBankAccount;
    /**
     * 노출용 환급 관리되는 유저
     * @type {ExchangeManagementUser}
     * @memberof AdminPatchStatusDataResponseDto
     */
    'exchangeManagementUser': ExchangeManagementUser;
}

export const AdminPatchStatusDataResponseDtoStatusEnum = {
    Application: 'application',
    Waiting: 'waiting',
    Completed: 'completed',
    Impossible: 'impossible'
} as const;

export type AdminPatchStatusDataResponseDtoStatusEnum = typeof AdminPatchStatusDataResponseDtoStatusEnum[keyof typeof AdminPatchStatusDataResponseDtoStatusEnum];


